import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

import {
  ArrowDownIcon,
  ArrowUpIcon
} from '../../../../assets/images/bk-wallet/icons';

const WalletTransaction = ({
  title,
  description,
  date,
  amount,
  type = 'credit',
  currency = '₹',
  onClick,
  showDivider = true,
  showIcon = true
}) => {
  const isCredit = ['credit', 'refund', 'cashback'].includes(type);

  const amountClass = isCredit
    ? 'wallet-transaction__amount--credit'
    : 'wallet-transaction__amount--debit';

  const renderIcon = () => {
    const iconSize = 34;
    if (isCredit) {
      return <ArrowDownIcon width={iconSize} height={iconSize} />;
    }

    return <ArrowUpIcon width={iconSize} height={iconSize} />;
  };

  return (
    <>
      <div role="presentation" className="wallet-transaction" onClick={onClick}>
        <div className="wallet-transaction__left">
          {showIcon && (
            <div className="wallet-transaction__icon">{renderIcon()}</div>
          )}

          <div className="wallet-transaction__details">
            <h4>{title}</h4>

            {description && (
              <p className="wallet-transaction__description">{description}</p>
            )}

            <span>{date}</span>
          </div>
        </div>

        <div className={`wallet-transaction__amount ${amountClass}`}>
          {isCredit ? '+' : '-'}
          {currency}
          {Number(amount).toFixed(2)}
        </div>
      </div>

      {showDivider && <div className="wallet-transaction__divider" />}
    </>
  );
};

WalletTransaction.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  date: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['credit', 'debit', 'refund', 'cashback', 'expired']),
  currency: PropTypes.string,
  onClick: PropTypes.func,
  showDivider: PropTypes.bool,
  showIcon: PropTypes.bool
};

export default WalletTransaction;
